module.exports = __webpack_public_path__ + "img/about.69459575.jpg";